/* src/app/main/declaration-reports/data-status/data-status.component.scss */
/*# sourceMappingURL=data-status.component-ECED24QI.css.map */
